import {Decimal} from 'decimal.js';
import ImageUtils from '../../lib/ImageUtils';
import resizedDasWebUri from './ResizedDasWebImage';

export default function imagePreviewData(
    {
        image: {src, x: inputX = null, y: inputY = null, zoom = 1.0},
        resizeDimensions,
        viewDimensions,
    })
{
    const coverImageUri = resizedDasWebUri({
        uri: src,
        resizeDimensions,
    });

    const naturalSize = ImageUtils.naturalSize(src);
    const fittedViewSize = ImageUtils.fittedSize(viewDimensions, naturalSize);

    const zoomIn = new Decimal(zoom).pow(-1);
    const zoomedView = {
        width: new Decimal(fittedViewSize.width).times(zoomIn).round().toNumber(),
        height: new Decimal(fittedViewSize.height).times(zoomIn).round().toNumber(),
    };

    const xDiff = Math.max(0, naturalSize.width - zoomedView.width);
    const yDiff = Math.max(0, naturalSize.height - zoomedView.height);
    const x = inputX ?? Math.round(xDiff / 2);
    const y = inputY ?? Math.round(yDiff / 2);

    return {
        image: {
            uri: coverImageUri,
            width: naturalSize.width,
            height: naturalSize.height,
        },
        view: {
            width: zoomedView.width,
            height: zoomedView.height,
            x,
            y,
        },
    };
}
